import { postJson } from "../Utils/apiUtils.js";

const getRankingNationCode = (nation) => {
  if (nation === "한국" || nation === "대한민국") return "kr";
  if (nation === "중국") return "cn";
  if (nation === "미국") return "us";
  if (nation === "일본") return "jp";
  if (nation === "인도") return "in";
  if (nation === "싱가포르") return "sg";
  if (nation === "대만") return "tw";

  return "";
};

export const requestMemberCounts = ({ navigate }) =>
  postJson("/dashboard/user/getTotalCount", {}, navigate);

export const requestDepartmentList = ({ navigate }) =>
  postJson("/dashboard/department/getList", {}, navigate);

export const requestMemberList = ({
  page,
  offset,
  filterParams,
  navigate,
}) =>
  postJson(
    "/dashboard/user/getList",
    {
      page,
      offset,
      ...filterParams,
    },
    navigate
  );

export const requestRankingList = ({
  page,
  period,
  nationForRanking,
  navigate,
}) =>
  postJson(
    "/dashboard/user/getRankingList",
    {
      page,
      offset: 20,
      period,
      cCode: getRankingNationCode(nationForRanking),
    },
    navigate
  );

export const requestMemberExcelList = ({
  filterParams,
  navigate,
}) => postJson("/dashboard/user/getExcelList", filterParams, navigate);
